export var Snackbars;

(function (Snackbars) {
  Snackbars["Success"] = "Success";
  Snackbars["Error"] = "Error";
  Snackbars["Info"] = "Info";
})(Snackbars || (Snackbars = {}));